exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-entity-dialog .table-cell:last-child {\n  text-align: right;\n}\n.share-entity-dialog .no-results-message .table-cell {\n  text-align: center;\n}\n.share-entity-dialog .table-cell:last-child .icon-wrapper {\n  cursor: pointer;\n}\n", ""]);

// exports
